import './OrganisationProfileCover.scss'

export default function OrganisationProfileCover({ coverImage, profileImage }) {
    return (
        <div className="OrganisationProfileCover">
            <div className='cover-container' style={{ backgroundImage: `url(${coverImage})` }}>
                
            </div>
            <div className='profile-container' style={{ backgroundImage: `url(${profileImage})` }}></div>
        </div>
    );
}
